if ( typeof ProductPage !== 'function' ) {
	class ProductPage extends HTMLElement {
		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');
			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			this.dynamicBlocks = [
				"data-js-badge-block",
				"data-js-title-block",
				"data-js-price-block",
				"data-js-offer-block",
				"data-js-toggle-group-block",
				"data-js-cross-sell-block",
				"data-js-product-gallery-block",
				"data-js-additional-price-block"
			];

			// Mount gallery
			this.mountGallery();

			// Product variant event listener for theme specific logic
			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');

			// Use event delegation - bind once to a parent that doesn't get replaced
			this.addEventListener('click', async (e) => {
				const elm = e.target.closest('[data-js-merged-option], [data-js-custom-option]');
				if (!elm) return;

				e.preventDefault();

				  // Immediately stop image loading to free bandwidth
 				 this.querySelectorAll('[data-js-product-gallery] img').forEach(img => {
					// Only blur if image is already loaded (has current src)
					if (img.complete && img.naturalWidth > 0) {
					  img.style.filter = 'blur(2px)';
					  img.style.opacity = '0.7';
					} else {
					  img.style.visibility = 'hidden';
					  img.src = '';
					  img.srcset = '';
					  img.sizes = '';
					}
				  });
				
				// Add loading state immediately
				elm.style.pointerEvents = 'none';
				elm.style.opacity = '0.7';
				
				try {
				  const decoded_variant = JSON.parse(decodeURIComponent(elm.dataset.currentOptions.replace(/\+/g, ' ')));

				  const fetchUrl = `${window.location.origin}${elm.dataset.href}?section_id=${elm.dataset.sectionId}`;
				  
				  // Add fetch timeout for slower connections
				  const controller = new AbortController();
				  const timeoutId = setTimeout(() => controller.abort(), 10000);
				  
				  const response = await fetch(fetchUrl, { 
					signal: controller.signal,
					priority: 'high'
				  });
				  clearTimeout(timeoutId);
				  
				  if (!response.ok) {
					throw new Error(`Failed to fetch variant data: ${response.status}`);
				  }
				  const data = await response.text();
				  
				  const parsedData = new DOMParser().parseFromString(data, 'text/html');

				  
				  // Update different sections modularly
				  setTimeout(()=>{
				  this.updateProductForm(parsedData);
					this.updateProductVariants(parsedData);
					this.keepOptions(decoded_variant);
					this.updateDynamicBlocks(parsedData);
				  }, 0);
				  
				} catch (error) {
				  if (error.name === 'AbortError') {
					console.error('Variant selection timed out');
				  } else {
					console.error('Variant selection error:', error);
				  }
				} finally {
				  // Remove loading state
				  elm.style.pointerEvents = '';
				  elm.style.opacity = '';
				}
			  });
  



			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}

			

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				this.ajaxifyProductForm();
			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}


		}

		updateDynamicBlocks(html) {
			this.dynamicBlocks.forEach(blockSelector => {
				const currentBlocks = this.querySelectorAll(`[${blockSelector}]`);
				const newBlock = html.querySelector(`[${blockSelector}]`);
				
				console.log('Updating block:', blockSelector, 'Found blocks:', currentBlocks.length);
				
				currentBlocks.forEach(block => {
					if (newBlock) {
						block.innerHTML = newBlock.innerHTML;
						block.style.display = '';
						
						// Special handling for gallery blocks
						if (blockSelector === 'data-js-product-gallery-block') {
							console.log('Gallery block update triggered');
							// Preserve gallery expanded state
							const wasExpanded = this.dataset.galleryExpanded === 'true';
							
							// Re-initialize gallery components
							this.productSlider = block.querySelector('css-slider');
							this.productGallery = block;
							this.mountGallery();
							this.thumbnailNavigationHelper();
							
							// Restore gallery expanded state if it was expanded
							if (wasExpanded) {
								this.restoreGalleryExpansion();
							}
						}
					} else {
						block.style.display = 'none';
					}
				});
			});
		}

		ajaxifyProductForm() {
			let addToCartEnter = false;
			if ( this.querySelector('[data-js-product-add-to-cart]') ) {
				this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						addToCartEnter = true;
					}
				})
			}	

			if ( this.querySelector('[data-js-product-form]') ) {
				this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
					document.getElementById('site-cart-sidebar').show();
					if ( document.getElementById('cart-recommendations-sidebar') ) {
						document.getElementById('cart-recommendations-sidebar').classList.add('loading');
						document.getElementById('cart-recommendations-sidebar').generateRecommendations();
					}
					if ( addToCartEnter ) {
						setTimeout(()=>{
							document.querySelector('#site-cart-sidebar [data-js-close]').focus();
						}, 200);
					}
				});
			}

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}
		}
		
		mountGallery() {
			// Gallery thumbnails
			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top + window.scrollY,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							this._pauseAllMedia();
							this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{

						const media = this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`);
						const video = media.querySelector('video-popup [data-js-video-popup-link]');
						
						this.thumbnailNavigationHelper(e.target.index);
						if ( video ) {
							video.click();
						}
						
					});

				}

				this.productSlider.addEventListener('navigation', e=>{
					this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
				})
				this.productSlider.addEventListener('change', e=>{
					this._pauseAllMedia();
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}
				});

			}
		}

		keepOptions(decoded_variant) {
			if (!this.productVariants) return;
		
			const historicalVariant = this.productVariants.getVariantData().find(variant => 
			variant.options.every((opt, i) => opt.toLowerCase() === decoded_variant[i].toLowerCase())
		);
		
		if (historicalVariant) {
			const variantContainers = this.productVariants.querySelectorAll('[data-js-product-variant]');
			
			historicalVariant.options.forEach((option, i) => {
			const container = variantContainers[i]?.querySelector('[data-js-product-variant-container]');
			if (!container) return;

			if (container.dataset.jsProductVariantContainer === 'radio') {
				const input = container.querySelector(`input[value="${option.replace(/"/g, '\\"')}"]`);
				if (input) input.checked = true;
			}
			});

			this.productVariants.onVariantChange();
			
		}
		}
		// Modular update methods
		updateProductForm(html) {
			const newProductForm = html.querySelector('[data-js-buy-buttons-block]');	
			const productForm = this.querySelector('[data-js-buy-buttons-block]');
			if (productForm && newProductForm) {
			productForm.replaceWith(newProductForm);
			this.productForm = newProductForm; // Update reference to new element
			this.ajaxifyProductForm();
			}
		}
		updateProductVariants(html) {
			const newProductVariants = html.querySelector('product-variants[data-main-product-variants]');	
			if (this.productVariants && newProductVariants) {
			this.productVariants.replaceWith(newProductVariants);
			this.productVariants = newProductVariants; // Update reference to new element
			this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
			this.onVariantChangeHandler({target:this.productVariants});
			}
		}
		
		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){
			
			let variant = e.target.currentVariant;
			if ( variant ) {

				if ( variant.options[0]) {
					this.setAttribute('data-option-1', variant.options[0]);
				}

				// image handling

				// if ( variant.featured_media != null ) {
				// 	let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
				// 	if ( variantImg ) {
				// 		if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
				// 			if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
				// 				this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
				// 			} else {
				// 				this.firstProductGalleryIndex = variantImg.dataset.index;
				// 			}
				// 		} else {
				// 			window.scrollTo({
				// 				top: variantImg.getBoundingClientRect().top + window.scrollY,
				// 				behavior: 'smooth'
				// 			});
				// 		}
				// 	}
				// }

				// refresh pickup availability widgets

				if ( this.pickupAvailabilityExtended && this.pickupAvailabilityExtended.classList.contains('active') ) {
					this.querySelector('pickup-availability-extended').fetchAvailability(variant.id);
				}

				e.target.querySelectorAll(".product-variant__item--radio:has(input:checked)").forEach(
					(elm) => {
						const input = elm.querySelector('input:checked'); // Use :checked instead of [checked]
						const label = input.closest('.variant-wrapper').querySelector('.product-variant__item-text-label');
						label.textContent = input.value;
					}
				);

        }



		}

		_pauseAllMedia(){

			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI ) 
					model.modelViewerUI.pause()
			});
		}
		
		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

		toggleGalleryExpansion() {
			const gallery = this.querySelector('.product-gallery');
			const gridContainer = gallery?.querySelector('.grid--layout.grid-2');
			const button = gallery?.querySelector('.product-gallery__show-more-btn');
			
			if (!gallery || !gridContainer || !button) return;
			
			const showText = button.querySelector('.show-text');
			const hideText = button.querySelector('.hide-text');
			const isExpanded = this.dataset.galleryExpanded === 'true';
			
			if (isExpanded) {
				gridContainer.classList.remove('gallery-expanded');
				showText.style.display = 'inline';
				hideText.style.display = 'none';
				this.dataset.galleryExpanded = 'false';
				gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
			} else {
				gridContainer.classList.add('gallery-expanded');
				showText.style.display = 'none';
				hideText.style.display = 'inline';
				this.dataset.galleryExpanded = 'true';
			}
		}

		restoreGalleryExpansion() {
			const gallery = this.querySelector('.product-gallery');
			const gridContainer = gallery?.querySelector('.grid--layout.grid-2');
			const button = gallery?.querySelector('.product-gallery__show-more-btn');
			
			if (!gallery || !gridContainer || !button) return;
			
			const showText = button.querySelector('.show-text');
			const hideText = button.querySelector('.hide-text');
			
			// Apply expanded state without animation
			gridContainer.classList.add('gallery-expanded');
			showText.style.display = 'none';
			hideText.style.display = 'inline';
			this.dataset.galleryExpanded = 'true';
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}


if ( typeof productPrice !== 'function' ) {
	class productPrice extends HTMLElement {
		constructor() {
			super();

			this.priceOriginal = this.querySelector('[data-js-product-price-original]');
			this.priceCompare = this.querySelector('[data-js-product-price-compare]');
			
			this.closestSection = this.closest('.shopify-section');
			
			if ( this.closestSection ) {
				console.log('closestSection', this.closestSection);
				this.productVariants = this.closestSection.querySelector(`product-variants[data-main-product-variants][data-id="${this.dataset.id}"]`);
				console.log('productVariants', this.productVariants);
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
			}
		}

		onVariantChangeHandler(e){
			console.log('onVariantChangeHandler', e);

			let variant = e.target.currentVariant;
			if (!variant ) {
				this.classList.add('hide')
			} else {
				this.classList.remove('hide')
				this.priceOriginal.innerHTML = this.productVariants._formatMoney(variant.price, KROWN.settings.shop_money_format);
				if ( variant.compare_at_price > variant.price ) {
					this.priceCompare.innerHTML = this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format);
				} else {
					this.priceCompare.innerHTML = '';
				}
			}
		}
	}

	if ( typeof customElements.get('product-price') == 'undefined' ) {
		customElements.define('product-price', productPrice);
	}
}